import { render, staticRenderFns } from "./DormantAfterTrialSettings.vue?vue&type=template&id=1b74bf1e&scoped=true"
import script from "./DormantAfterTrialSettings.vue?vue&type=script&lang=js"
export * from "./DormantAfterTrialSettings.vue?vue&type=script&lang=js"
import style0 from "./DormantAfterTrialSettings.vue?vue&type=style&index=0&id=1b74bf1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b74bf1e",
  null
  
)

export default component.exports